import styled, { css } from 'styled-components';
import { spacing } from 'ui/theme/utils';

export const Label = styled.label`
  ${({ flex }) => flex && `flex: ${flex};`}
  ${({ variant }) => {
    switch (variant) {
      case 'legend':
        return css`
          font-size: ${({ fontSize = '14px' }) => fontSize};
          letter-spacing: 0.04em;
          font-weight: ${({ fontWeight = 'normal' }) => fontWeight};
          color: ${({ theme }) => theme.colors.grey};
          > span.highlighted,
          > a {
            color: ${({ theme }) => theme.colors.primary};
          }
          > a {
            text-decoration: underline;
          }
        `;
      default:
        return css`
          font-size: ${({ fontSize = '14px' }) => fontSize};
          letter-spacing: 0.62px;
          font-weight: ${({ fontWeight = 500 }) => fontWeight};
          color: ${({ color = 'primary', theme }) => theme.colors[color] || color};
        `;
    }
  }}
  text-align: left;
  ${(props) => spacing(props)}
`;
